<template>
    <div>
        <div class="OperationBar">
            <el-button type="primary" plain @click="handleClickAddNew">添加新闻</el-button>
            <el-button type="info" plain @click="handleClickDelete">删除</el-button>
        </div>
        <div style="width:100%;">
            <el-table ref="newsList" :data="tableData" style="width: 100%;">
                <el-table-column fixed type="selection" width="55" />
                <el-table-column fixed prop="id" label="新闻ID" />
                <el-table-column prop="title" label="新闻标题" />
                <el-table-column prop="status" label="新闻状态" />
                <el-table-column prop="attchs" label="新闻小图" width="330">
                    <template #default="scope" >
                        <div  v-if="scope.row.attchs.length !== 0" >
                            <div style="display: inline-flex; ">
                                <el-image v-for="(item, index ) in scope.row.attchs" style="width: 100px; height: 100px; border:1px solid #ccc; margin-right:5px;" :src="this.tempPicUrl.filter(e=> e.id === scope.row.attchs[index])[0]?.url"  :key="item" />
                            </div>
                        </div>
                        
                    </template>
                </el-table-column >
                <el-table-column prop="updatedTime" label="更新时间">
                </el-table-column >
                <el-table-column fixed="right" label="操作">
                    <template #default="scope">
                        <el-button link type="primary" size="small" @click.prevent="modifyNewsRow( scope.row )">编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                small
                background
                layout="prev, pager, next"
                :total="this.totalRows"
                :page-count="this.totalPage"
                @current-change="hanldeCurrentPage"
                class="mt-4" style="margin: 7px 15px;">
            </el-pagination>
        </div>
        <addNewsDialog :isAddNewsShow="isAddNewsShow" :timekey="timerAdd" @hanldeCurrentPage="hanldeCurrentPage"></addNewsDialog>
        <modifyNewsDialog :isModifyNewsShow="isModifyNewsShow" :currentNewsDetial="currentRow" :timekey="timerModify" @hanldeCurrentPage="hanldeCurrentPage"></modifyNewsDialog>
    </div>
</template>

<script>
import addNewsDialog from './child/addNewsDialog'
import modifyNewsDialog from './child/modifyNewsDialog'
import api from '@/api/api';
import cxf from '@/utils/GeneralFn';
    export default {
        name: "newsManage",
        components: {
            addNewsDialog,
            modifyNewsDialog
         },
        data() {
            return {
                isAddNewsShow:false,
                isModifyNewsShow:false,
                newsListParam:{
                    PageNo:1,
                    PageSize:10,
                },
                timerAdd:0,
                timerModify:0,
                totalPage:1,
                totalRows:1,
                tableData:[],
                tempPicUrl:[],
                currentRow:[]
            }
        },
        created(){
           
        },
        mounted(){
            this.getNewsList();
        },
        methods:{
            async getNewsList () {
                const _resList = await api.postNewsList( this.newsListParam );
                if ( _resList.data.success ) {
                    const _tableList = _resList.data.data;
                    this.totalPage = _resList.data.data.totalPage;
                   
                    this.totalRows = _resList.data.data.totalRows;
                    this.tableData = _tableList.rows;
                    this.tableData.forEach( async e => {
                        e.status = cxf.getNewStatus( e.status, true );
                        for ( let d in e.attchs) {
                           await this.getImage(e.attchs[d]);
                        }
                    });
                } else {
                    this.$message({
                        message: _resList.data.message,
                        type: 'warning'
                    });
                }
            },
            async getImage( id ) {
                if (id) {
                    let _tempRes = await api.getSysFileInfoPreview({id: id});
                        if ( _tempRes.status === 200 ) {
                            return this.tempPicUrl.push({ id:id,url:window.URL.createObjectURL(new Blob([_tempRes.data]))})
                        } else {
                            return '--';
                        }
                    
                } else {
                    return "无图片"
                }
                
            },
            hanldeCurrentPage( pageNum ){
                this.newsListParam.PageNo = pageNum || 1;
                this.getNewsList();
            },
            handleClickAddNew () {
                this.timerAdd = new Date().getTime();
                this.isAddNewsShow = true;
            },
            handleClickDelete() {
                const _deleteFromData = new FormData();
                const _selectedIds = this.$refs.newsList.getSelectionRows().map(e => e.id);
                for (let i = 0; i < _selectedIds.length; i++) {
                    _deleteFromData.append( "inputs",_selectedIds[i]);
                }
                _deleteFromData.append("apiType", "fromData");
                api.postDeleteNews( _deleteFromData ).then( res => {
                    if ( res.status ) {
                        this.hanldeCurrentPage( 1 );
                    }
                }).catch( err => {
                    console.log(err);
                });
            },
            modifyNewsRow ( row ) {
                this.currentRow = row;
                this.timerModify = new Date().getTime();
                this.isModifyNewsShow = true;
            }
        },
        watch:{
            isAddNewsShow( nv ) {
                this.isAddNewsShow = nv;
            },
            isModifyNewsShow ( nv ) {
                this.isModifyNewsShow = nv;
            }
        }
    }
</script>


<style scoped>
</style>